import { matchPath } from "react-router-dom";

/**
 * Traduz a URL atual para o nome da tela no catálogo de uso do Backend
 * (UsageEventNames.Screens). Os nomes precisam bater com o de lá: nome
 * desconhecido é ignorado pelo Backend, sem erro.
 *
 * Tela fora deste mapa (páginas de demonstração, admin interno, link
 * público) simplesmente não é registrada.
 */

// Em Gestão o relatório vem da query string, não do caminho: sem isso, os
// seis relatórios apareceriam como uma tela só.
const GESTAO_MODEL_SCREENS = {
  cashflow: "gestao.fluxo_caixa.visualizar",
  payrec: "gestao.pagar_receber.visualizar",
  dredfc: "gestao.dre.visualizar",
  indicators: "gestao.indicadores.visualizar",
  balances: "gestao.saldos.visualizar",
  sales: "gestao.vendas.visualizar",
};

// Mesmo default de pages/Reports/standard/hooks/useStandardUrlState.js.
const DEFAULT_GESTAO_MODEL = "cashflow";

const ADVANCED_TAB_SCREENS = {
  reports: "studio.relatorios.visualizar",
  portfolios: "studio.agrupamentos.visualizar",
  pdf_exports: "gestao.exportacao_pdf.visualizar",
};

// Planos é uma aba das Configurações: mantém o nome de tela que tinha quando era a rota /billing.
const COMPANY_TAB_SCREENS = {
  planos: "conta.planos.visualizar",
};
const DEFAULT_COMPANY_SCREEN = "conta.configuracoes.visualizar";

// A ordem importa: o primeiro padrão que casa vence (ex.: /closing-reports/dashboard
// antes de /closing-reports/:id).
const ROUTE_SCREENS = [
  ["/closing-reports/dashboard", "fechamento.dashboard.visualizar"],
  ["/closing-reports/:id", "fechamento.editor.visualizar"],
  ["/closing-reports", "fechamento.lista.visualizar"],
  ["/planejamento/simulador", "planejamento.simulador.visualizar"],
  ["/planejamento/metas", "planejamento.metas.visualizar"],
  ["/gestao/orcamentario", "gestao.orcamentario.visualizar"],
  ["/reports/builder/:id", "studio.construtor.visualizar"],
  ["/reports/sync-selector/*", "studio.fonte_dados.visualizar"],
  ["/portfolio/configurator/*", "studio.agrupamento_config.visualizar"],
  ["/projects/:projectId/settings", "studio.projeto_config.visualizar"],
  ["/projects/:projectId/integrations/*", "studio.projeto_integracoes.visualizar"],
  ["/projects", "studio.projetos.visualizar"],
  ["/synchronizations/settings/*", "sync.configuracao.visualizar"],
  ["/synchronizations/*", "sync.empresas.visualizar"],
  ["/academy", "ajuda.central.visualizar"],
  ["/users-permissions", "conta.usuarios.visualizar"],
];

export const resolveUsageScreen = (pathname, search) => {
  const params = new URLSearchParams(search || "");

  if (matchPath("/reports", pathname)) {
    return GESTAO_MODEL_SCREENS[params.get("model") || DEFAULT_GESTAO_MODEL] || null;
  }

  if (matchPath("/reports/advanced", pathname)) {
    // Sem ?tab a página redireciona para a aba permitida ao usuário; registra
    // só depois do redirect, para não contar uma aba que ele nem viu.
    const tab = params.get("tab");
    return tab ? ADVANCED_TAB_SCREENS[tab] || null : null;
  }

  if (matchPath("/company", pathname)) {
    return COMPANY_TAB_SCREENS[params.get("tab")] || DEFAULT_COMPANY_SCREEN;
  }

  const match = ROUTE_SCREENS.find(([pattern]) => matchPath(pattern, pathname));
  return match ? match[1] : null;
};
